import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { modalStyle } from "../../../../../../../../components/modalStyle";
import {
  createRow,
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { lightTable } from "../../../../../../../../styles/muiProps";
import { secondAxios } from "../../../../../../../../api/axios";
import { useParams } from "react-router-dom";
import { useMcsContext } from "../../../MCS.context";
import { mrqRegisterColumns } from "./columns";

const isNumeric = (value) => value !== null && value !== "" && !isNaN(value);

export const getFirstTwoParts = (taskCode = "") => {
  const parts = taskCode.split(".").map((part) => part.trim());

  if (parts.length < 2) return null;

  if (!isNumeric(parts[1])) return null;

  return `${parts[0]}.${parts[1]}`;
};

const getGroupName = (taskCode = "") => {
  return getFirstTwoParts(taskCode);
};

export default function MrqRegister() {
  const { plantId } = useParams();
  const { plant, setPlant } = useMcsContext();

  const [openModal, setOpenModal] = React.useState(false);
  const [allMrqs, setAllMrqs] = useState([]);
  const [data, setData] = useState([]);
  const [tasksGroups, setTasksGroups] = useState([]);
  const [groupedTasks, setGroupedTasks] = useState({});
  const [tasks, setTasks] = useState([]);
  const [createRowErrors, setCreateRowErrors] = useState({});

  const [perProjectOrAll, setPerProjectOrAll] =
    React.useState("For All Plants");

  const requiredFields = ["mrqNumber", "rev", "title", "wbs", "mrqDate"];

  const getMrqs = async () => {
    const res = await secondAxios.get("mrq");
    console.log("mrqssss from list:", res.data);

    const mrqs = res?.data?.map((m) => {
      return {
        ...m,
        plantName: m.plant?.name || "",
      };
    });
    setAllMrqs(mrqs);
    setData(mrqs);
  };
  const getTasks = async () => {
    const res = await secondAxios.get("task/all/plant/" + plantId);
    console.log("tasks in mrq registeer table", res);

    if (res.data) {
      const procurementsTasks =
        res?.data?.filter((t) => t.type === "procurement") || [];

      const uniqueGroups = [
        ...new Set(
          procurementsTasks
            .map((item) => getGroupName(item.taskCode))
            .filter(Boolean)
            .sort((a, b) => a - b),
        ),
      ];
      console.log("uniqueGroups", uniqueGroups);
      setTasksGroups(uniqueGroups);

      const groupedData = procurementsTasks.reduce((acc, item) => {
        const key = getFirstTwoParts(item.taskCode);

        if (!acc[key]) acc[key] = [];
        acc[key].push(item);

        return acc;
      }, {});

      setGroupedTasks(groupedData);

      setTasks(procurementsTasks);
    }
  };

  useEffect(() => {
    getMrqs();
    getTasks();
  }, []);

  const onClickList = (table) => {
    setOpenModal(true);
    table?.setCreatingRow(null);
  };
  const onClickAddNew = (table) => {
    setOpenModal(true);
    table?.setCreatingRow(createRow(table, { plantName: plant?.name }));
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleChange = (event) => {
    setPerProjectOrAll(event.target.value);

    if (event.target.value === "For All Plants") {
      setData(allMrqs);
    } else {
      setData(allMrqs.filter((m) => m.plantId === plantId));
    }
  };

  console.log({
    tasks,
    tasksGroups,
    groupedTasks,
    createRowErrors,
  });

  const table = useMaterialReactTable({
    data,
    columns: mrqRegisterColumns({
      tasks,
      tasksGroups,
      groupedTasks,
      createRowErrors,
    }),
    ...lightTable,
    createDisplayMode: "row",
    editDisplayMode: "row",
    enableEditing: true,
    enableCreatingRow: true,
    positionCreatingRow: "bottom",
    enableRowActions: false,
    onCreatingRowChange: (updater) => {
      const newRow =
        typeof updater === "function"
          ? updater(table.getState().creatingRow)
          : updater;
      if (newRow) {
        const newErrors = { ...createRowErrors[newRow.id] };
        requiredFields.forEach((field) => {
          if (newRow.values && newRow.values[field] && newErrors[field]) {
            delete newErrors[field];
          }
        });
        setCreateRowErrors((prev) => ({ ...prev, [newRow.id]: newErrors }));
      }
    },
    state: {
      columnVisibility: {
        "mrt-row-actions": false,
      },
    },
  });

  const onSaveNewMrq = async () => {
    const creatingRow = table.getState().creatingRow;

    const values = creatingRow
      ? creatingRow.getAllCells
        ? Object.fromEntries(
            creatingRow
              .getAllCells()
              .map((cell) => [cell.column.id, cell.getValue()]),
          )
        : creatingRow.values
      : null;

    console.log("values", values);

    if (!values) return;

    // Validate required fields
    const errors = {};
    requiredFields.forEach((field) => {
      if (!values[field]) {
        errors[field] = true;
      }
    });

    if (Object.keys(errors).length > 0) {
      setCreateRowErrors((prev) => ({ ...prev, [creatingRow.id]: errors }));
      return;
    }

    // Clear errors if valid
    setCreateRowErrors((prev) => ({ ...prev, [creatingRow.id]: {} }));

    // TODO: send values to API, e.g.:
    const code = values.wbs?.split("-").slice(1).join("-");

    console.log("tasks", tasks, code);
    const task = tasks.find((t) => t.task === code);

    delete values.materialsNumber;
    const body = { ...values, taskId: task.id };
    console.log(body);

    const res = await secondAxios.post("mrq", body);

    console.log("res", res);
    if (res?.data?.mrq?.id) {
      setData((prev) => [...prev, values]);

      // Close the creation row editor
      table.setCreatingRow(null);

      setPlant({ ...plant, mrqs: [...plant.mrqs, res?.data?.mrq] });
    }
  };

  return (
    <Box>
      <Button
        variant="outlined"
        startIcon={<FormatListBulletedIcon />}
        sx={{ mt: 3, mr: 1 }}
        onClick={() => onClickList(table)}
      >
        MRQ List
      </Button>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        sx={{ mt: 3 }}
        onClick={() => onClickAddNew(table)}
      >
        Add New MRQ
      </Button>

      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={{ ...modalStyle, maxHeight: "90%" }}>
          <Box>
            <Typography variant="h6" component="h2" mb={2}>
              MRQ Register
              <Box sx={{ float: "right" }}>
                <RadioGroup row value={perProjectOrAll} onChange={handleChange}>
                  <FormControlLabel
                    value="For this Plant"
                    control={<Radio />}
                    label="For this Plant"
                  />
                  <FormControlLabel
                    value="For All Plants"
                    control={<Radio />}
                    label="For All Plants"
                  />
                </RadioGroup>
              </Box>
            </Typography>
          </Box>

          <Box sx={{ "& .MuiPaper-root": { width: "100%" } }}>
            <MaterialReactTable table={table} />
          </Box>

          <Box sx={{ textAlign: "right", pt: 1 }}>
            {table.getState().creatingRow ? (
              <>
                <Button
                  variant="outlined"
                  sx={{ mr: 1 }}
                  onClick={() => table.setCreatingRow(null)}
                >
                  Cancel
                </Button>
                <Button variant="contained" onClick={onSaveNewMrq}>
                  Save
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => onClickAddNew(table)}
              >
                Add New MRQ
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
